/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type UpdateCustomerStatisticsInput = {
    description?: string | null | undefined;
    id: string;
    name?: string | null | undefined;
    wavecareBoxIds?: Record<string, any> | null | undefined;
};
export type apiUpdateCustomerStatisticsMutationVariables = {
    input: UpdateCustomerStatisticsInput;
};
export type apiUpdateCustomerStatisticsMutationResponse = {
    readonly updateCustomerStatistics: {
        readonly customerStatistics: {
            readonly id: string;
            readonly name: string;
            readonly description: string;
            readonly wavecareBoxIds: Record<string, any>;
        };
    };
};
export type apiUpdateCustomerStatisticsMutation = {
    readonly response: apiUpdateCustomerStatisticsMutationResponse;
    readonly variables: apiUpdateCustomerStatisticsMutationVariables;
};



/*
mutation apiUpdateCustomerStatisticsMutation(
  $input: UpdateCustomerStatisticsInput!
) {
  updateCustomerStatistics(input: $input) {
    customerStatistics {
      id
      name
      description
      wavecareBoxIds
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateCustomerStatisticsPayload",
    "kind": "LinkedField",
    "name": "updateCustomerStatistics",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "CustomerStatistics",
        "kind": "LinkedField",
        "name": "customerStatistics",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "description",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "wavecareBoxIds",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "apiUpdateCustomerStatisticsMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "apiUpdateCustomerStatisticsMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "7e2a258274dcf4b94695b53ce862d312",
    "id": null,
    "metadata": {},
    "name": "apiUpdateCustomerStatisticsMutation",
    "operationKind": "mutation",
    "text": "mutation apiUpdateCustomerStatisticsMutation(\n  $input: UpdateCustomerStatisticsInput!\n) {\n  updateCustomerStatistics(input: $input) {\n    customerStatistics {\n      id\n      name\n      description\n      wavecareBoxIds\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = '350cf580348a033bcc56a9f33c930078';
export default node;
